function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuSideNav = function SvgMenuSideNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23.26 5.333H8.74C7.596 5.333 6.668 6.527 6.668 8v18.667c0 1.472.928 2.666 2.074 2.666h14.518c1.146 0 2.074-1.194 2.074-2.666V8c0-1.473-.928-2.667-2.074-2.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.fill,
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.333 20.907H10.667a5.333 5.333 0 1 1 10.666 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M9.6 20.907h12.8M17 13.867a1 1 0 1 0-2 0h2Zm-2 0V16h2v-2.133h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.319 3.84H12.68c-.523 0-.948.212-.948.474v3.319c0 .262.425.474.948.474h6.638c.523 0 .948-.212.948-.474V4.314c0-.262-.425-.474-.948-.474Z"
  }));
};
export default SvgMenuSideNav;